import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { OtherSkillSuggestion, Technology } from '../models/technology';

@Injectable({
  providedIn: 'root',
})
export class TechnologyService {
  API_URL = `${environment.apiUrl}/technologies`;

  constructor(private http: HttpClient) {}

  getAllTechnologies(): Observable<Technology[]> {
    return this.http.get<Technology[]>(this.API_URL).pipe(
      map(technologies => technologies.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  getTechnologyById(id: number): Observable<Technology> {
    return this.http.get<Technology>(`${this.API_URL}/${id}`);
  }

  getOtherSkillSuggestions(): Observable<OtherSkillSuggestion[]> {
    return this.http.get<OtherSkillSuggestion[]>(`${this.API_URL}/other-skill-suggestions`);
  }

  promoteOtherSkill(label: string): Observable<Technology> {
    return this.http.post<Technology>(`${this.API_URL}/other-skill-suggestions/promote`, { label });
  }

  addTechnology(technology: Technology): Observable<Technology> {
    return this.http.post<Technology>(this.API_URL, technology);
  }

  updateTechnology(technology: Technology): Observable<Technology> {
    return this.http.put<Technology>(`${this.API_URL}/${technology.id}`, technology);
  }

  deleteTechnology(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
